import React from "react";
import { SEO, MainLayout, QuoteApproved } from "../../../../components";

const QuoteApprovedPage = () => {
  return (
    <>
      <SEO title="quote approved" />
      <MainLayout>
        <QuoteApproved />
      </MainLayout>
    </>
  );
};

export default QuoteApprovedPage;
